import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=4ae198a3&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"
import style0 from "../assets/styles-new/product.sass?vue&type=style&index=0&id=4ae198a3&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae198a3",
  null
  
)

export default component.exports